import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Grid,
  Avatar,
  CardContent,
  Tooltip,
} from "@mui/material";
import TextButtonComponet from "../../../component/atom/Buttons/TextButton";
import {
  CourseRatingCard,
  OrientaionForm,
  SignUpForm,
} from "../../../component/molecule";
import DialogComponent from "../../../component/atom/Dialog/Dialog";
import { connect } from "react-redux";
import { Actions } from "../../../core/modules/Actions";
import { CourseTabContainer } from "../../../component/organism";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import _ from "lodash";
import {
  APPROXIMATESIGN,
  DEFAULT_CURRENCY,
  IMAGE_URL,
  THEME_COLORS,
  getText,
  onGetCurrencySymble,
} from "../../../core/Constant";
import { setTopLevelNavigator } from "../../../core/services/NavigationServicd";
import { IconButtonComponent, RadioButtonComponent } from "../../../component/atom";
import { HeaderStudent } from "../../../component/organism/Header";
import moment from "moment";

const CourseViewScreen = ({
  initCourse,
  getInitialCourseDetails,
  verifyToken,
  systemCurrency,
  getSystemCurrency,
  show,
  markWalkthroughAsSeen,
}) => {
  const location = useLocation();
  const [openPopup, setOpenPopup] = useState(false);
  const [signup, setSignUp] = useState(false);
  const [allCourse, setAllCourse] = useState(false);
  const [freeOrientation, setFreeOrientation] = useState(false);
  const [newcourse, setNewCourse] = useState([]);
  const [data, setData] = useState({});
  const [courseContent, setCourseContent] = useState([]);
  const params = useParams();
  const [courseId, setCourseId] = useState("");

  const [currencyList, setCurrencyList] = useState([]);
  const [currencyValue, setCurrencyValue] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState("");
  const [price, setPrice] = useState("")
  const [duration, setDuration] = useState("")
  const [isViewMorePlans, setViewMorePlans] = useState(false)
  const [selectedCurrency, setSelectedCurrency] = useState("")

  const [isShow, setIsShow] = useState(0);

  const isShowApproxiSign = selectedCurrency?.currency !== DEFAULT_CURRENCY
  
  useEffect(() => {
    setIsShow(show == 1);
  }, [show]);

  let currancyId = localStorage.getItem('GlobalCurrency');

  useEffect(() => {
    if (currencyValue && currencyList?.length > 0) {
      const selectedCurrency = currencyList?.find((c) => c?.id?.toString() === currencyValue?.toString())
      setSelectedCurrency(selectedCurrency)
      const currencyCode = selectedCurrency?.currency
      getInitialCourseDetails(currencyCode);
    }
  }, [currencyValue, currencyList])

  useEffect(() => {
    const list = _.map(systemCurrency, (item, index) => {
      return {
        id: item.id,
        currency: item.currency,
        currency_name: item.currency_name,
      };
    });
    setCurrencyList(list);
    setCurrencyValue(list[0]?.id);
  }, [systemCurrency]);

  const onCurrancyChange = (e) => {
    const Selectedvalue = getText(e);
    setCurrencyValue(Selectedvalue);

    localStorage.setItem("GlobalCurrency", Selectedvalue)
  };

  useEffect(() => {
    let newcurrancyId = localStorage.getItem('GlobalCurrency');
    setCurrencyValue(newcurrancyId)
  }, [])

  useEffect(() => {
    if (newcourse?.length > 0) {
      const course = newcourse?.[0]
      const plans = course?.course_currencies
      const plan = plans?.find((plan) => plan?.id?.toString() === selectedPlan?.id?.toString())
      setSelectedPlan(plan)
    }
  }, [newcourse])

  useEffect(() => {
    if (selectedPlan) {
      setDuration(selectedPlan?.duration_weeks)
      setPrice(selectedPlan?.price)
    }
  }, [selectedPlan])

  useEffect(() => {
    let courseId = location?.state?.courseId;
    let plan = location?.state?.selectedPlan
    setCourseId(courseId);
    setSelectedPlan(plan)
  }, [location, params]);

  const openInPopup = (item) => {
    setOpenPopup(true);
  };

  const navigate = useNavigate();
  const intervalRef = useRef(null);

  const onNavigate = (path, obj = {}) => {
    if (path) {
      navigate(path, obj);
    }
  };

  useEffect(() => {
    intervalRef.current = onNavigate;
    setTopLevelNavigator(intervalRef);
  }, [navigate]);
  const setCourse = () => {
    var course = initCourse.filter((course) => course.id == courseId);
    setNewCourse(course);
    setCourseContent(course.course_contents);
  };

  useEffect(() => {
    setAllCourse(initCourse);
    setCourse();
  }, [initCourse, courseId]);


  const handleRadioChange = (event, plans) => {
    const text = getText(event);
    const selectedPlan = plans?.find((plan) => plan?.id?.toString() === text?.toString());
    setSelectedPlan(selectedPlan);
  };

  const getCurrency = (selectedPlan) => {
    if (selectedPlan) {
      const currencySymbol = onGetCurrencySymble(
        _.get(selectedPlan, "currency.currency"),
      );
      localStorage.setItem("GlobalCurrency", selectedPlan?.currency_id);
      return `${selectedPlan?.price && isShowApproxiSign ? APPROXIMATESIGN : ""  }${currencySymbol}${selectedPlan?.price}`;
    } else {
      return "";
    }
  };

  return (
    <>
      <Box p={2} sx={{ backgroundColor: "#ffffff" }}>
        <Grid container>
          <Grid item>
            <Box>
              <IconButtonComponent
                onclick={() => navigate("/", { state: { selectedPlan } })}
                btnType="backbtn"
                btnText="Back"
              />
            </Box>
          </Grid>

          {isShow ?
            <HeaderStudent dashboard={true} onCurrancyChange={onCurrancyChange} currancy={currencyValue} newcurrancyList={currencyList} />
            : null
          }

        </Grid>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Box sx={{ maxWidth: 850 }}>
            <CardContent>
              {newcourse?.map((item, index) => {
                const indexValue = _.findIndex(_.get(item, 'course_currencies', []), i => {
                  return i.currency_id == currancyId
                });
                return (
                  <div key={`course-view-${index}`}>
                    <Grid container flexDirection={"column"} rowGap={3}>
                      <Grid item>
                        <Avatar
                          alt="Image"
                          src={IMAGE_URL + item?.course_image}
                          sx={{
                            width: '100%',
                            height: 220,
                            objectFit: "cover",
                            borderRadius: 4,
                            boxShadow:
                              "0px 15px 15px -7px rgba(53, 79, 73, 0.36)",
                          }}
                        />
                      </Grid>

                      <Grid item>
                        <CourseRatingCard
                          rating={item.averageRating}
                          pricetitle={"Price"}
                          price={`${selectedPlan ? getCurrency(selectedPlan) : ""}`}
                          durationtitle={"Duration"}
                          duration={`${item?.duration ? item?.duration : duration}` + " Weeks"}
                          title={item.name}
                        />
                      </Grid>
                      <Grid item sx={{
                        marginTop: "-20px"
                      }}>
                        <Grid container columnGap={1}>
                          {item?.is_free === 0 &&
                            item?.course_currencies?.length > 0 && (
                              <Grid item>
                                <Box
                                  display={"flex"}
                                  alignItems={"center"}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    bgcolor: THEME_COLORS.gray4,
                                    borderRadius: 2,
                                    pr: 1,
                                  }}
                                >
                                  {item?.course_currencies?.slice(0, 2)?.map((plan) => {
                                    const planName = plan?.plan_name || "";
                                    const needsTooltip = planName?.length > 17;
                                    const displayedText = needsTooltip
                                      ? `${planName?.substring(0, 17)}...`
                                      : planName;

                                    return (
                                      <Box display={"flex"} alignItems={"center"}>
                                        {
                                         (planName || (plan?.batch_month && plan?.batch_year)) && <RadioButtonComponent
                                          checked={
                                            selectedPlan?.id?.toString() ===
                                            plan?.id?.toString()
                                          }
                                          value={plan?.id?.toString()}
                                          handleChange={(event) => {
                                            handleRadioChange(event, item?.course_currencies);
                                          }}
                                        />
                                        }
                                        
                                        <p
                                          style={{
                                            fontFamily: "Montserrat, sans serif",
                                            fontSize: "100%",
                                            padding: 0,
                                            margin: 0,
                                            color: "#2d3945",
                                          }}
                                        >
                                          {needsTooltip ? (
                                            <Tooltip title={planName} placement="top" arrow>
                                              <span style={{ cursor: "pointer" }}>
                                                {displayedText}
                                              </span>
                                            </Tooltip>
                                          ) : (
                                            displayedText
                                          )}
                                        </p>
                                        <span
                                          style={{
                                            fontFamily: "Montserrat",
                                            fontWeight: 800,
                                            fontSize: 15,
                                            color: "#2d3945",
                                          }}
                                        >
                                          { planName ? " -" : "" }
                                          {` ${plan?.batch_month ? moment()
                                            .month(Number(plan?.batch_month) - 1)
                                            .format("MMMM") : "" } ${plan?.batch_year ? plan?.batch_year : "" }  `}
                                        </span>
                                      </Box>
                                    );
                                  })}
                                  {item?.course_currencies?.length > 2 && (
                                    <Box display={"flex"} alignItems={"center"} mr={1}>
                                      <Box
                                        sx={{
                                          pl: 2,
                                          cursor: "pointer",
                                        }}
                                        onClick={() => {
                                          setViewMorePlans(true)
                                          setSignUp(true);
                                        }}
                                      >
                                        <Typography
                                          component="span"
                                          color={THEME_COLORS.primary}
                                          fontWeight={700}
                                          fontSize={16}
                                        >
                                          View More
                                        </Typography>
                                      </Box>
                                    </Box>
                                  )}
                                </Box>
                              </Grid>
                            )}
                        </Grid>
                      </Grid>
                      <Grid item>
                          <Grid container justifyContent={"flex-end"}>
                            <Grid item xs={5} display={"flex"} justifyContent={"flex-end"}>
                              <TextButtonComponet
                              classStyle={"btn btn-enroll"}
                              text="Enroll Now"
                              onButtonClick={() =>{ 
                                setSignUp(true)
                                setViewMorePlans(false)
                              }}
                             />
                            </Grid>
                          </Grid>
                      </Grid>

                      <Grid item>
                        <Typography
                          className="text-description"
                          sx={{
                            color: " #2d3945",
                            fontSize: "22px",
                            fontWeight: 600,
                          }}
                        >
                          Description
                        </Typography>
                        <span className="text-paragraph">
                          <Typography style={{ display: 'flex', flexDirection: 'column' }} color={"#4a6375"} fontSize={12} fontWeight={700}>
                            {item.description && item.description.split('\n').map((line, idx, arr) => (
                              <span key={idx}>
                                {line}
                                {idx < arr.length - 1 && <br />}
                              </span>
                            ))}
                          </Typography>
                        </span>
                      </Grid>
                      <Grid item>
                        <CourseTabContainer courseData={item} onEnroll={() => setSignUp(true)} contentNamesOnly />
                      </Grid>
                      <Grid item>
                        <Grid display={'flex'} flexDirection={'row'} justifyContent={'space-between'} container>
                          <Grid item xs={5}>
                            <TextButtonComponet
                              classStyle={"btn btn-enroll btn-free"}
                              text="Free Orientation"
                              onButtonClick={() => setFreeOrientation(true)}
                            />
                          </Grid>

                          <Grid item xs={5}>
                            <TextButtonComponet
                              classStyle={"btn btn-enroll"}
                              text="Enroll Now"
                              onButtonClick={() =>{ 
                                setSignUp(true)
                                setViewMorePlans(false)
                                setSelectedPlan(selectedPlan);
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </div>
                );
              })}
            </CardContent>
          </Box>
        </Box>
      </Box>

      <DialogComponent
        isShowCloseButton={false}
        border={30}
        open={freeOrientation}
        backgroundColor="#fff"
        onClose={() => setFreeOrientation(false)}
      >
        <OrientaionForm
          item={newcourse[0]}
          onClose={() => setFreeOrientation(false)}
        />
      </DialogComponent>
      <DialogComponent
        isShowCloseButton={false}
        border={30}
        open={signup}
        backgroundColor="#fff"
        onClose={() =>{ 
          setSignUp(false)
          const oldSelectedPlan = { ...selectedPlan  }
          setSelectedPlan("");
          setSelectedPlan(oldSelectedPlan)
          setViewMorePlans(false)
        }}
      >
        <SignUpForm
          cardSelectedPlan={selectedPlan}
          selectedCurrencyOp={selectedCurrency}
          item={newcourse[0]}
          isViewMorePlans={isViewMorePlans}
          onClose={() =>{ 
            setSignUp(false) 
            const oldSelectedPlan = { ...selectedPlan  }
            setSelectedPlan("");
            setSelectedPlan(oldSelectedPlan)
            setViewMorePlans(false)
          }} />
      </DialogComponent>
    </>
  );
};

export default connect(
  (state) => ({
    initCourse: state.guest.get("initCourse"),
    systemCurrency: state.auth.get("systemCurrency"),
    show: state.common.get('show')
  }),
  {
    getInitialCourseDetails: Actions.guest.getInitialCourseDetails,
    signUp: Actions.auth.signUp,
    verifyToken: Actions.auth.verifyToken,
    getSystemCurrency: Actions.auth.getSystemCurrency,
    markWalkthroughAsSeen: Actions.course.markWalkthroughAsSeen,
  }
)(CourseViewScreen);


